// extracted by mini-css-extract-plugin
export default {"cls1":"FacebookDisabledPage-cls1___74c04c1a1027ebdbfec","cls2":"FacebookDisabledPage-cls2___5457bd723e42af1819a FacebookDisabledPage-cls1___74c04c1a1027ebdbfec"};